import React, { useEffect, useRef, useState } from "react";

import shapeImg1 from "../../assets/img/contact/shape-1-1.png";
import shapeImg2 from "../../assets/img/contact/shape-1-2.png";
import shapeImg3 from "../../assets/img/contact/shape-1-3.png";
import shapeImg4 from "../../assets/img/contact/shape-1-4.png";
import titleImg from "../../assets/img/category/title.svg";
import contactBG from "../../assets/img/contact/bg-5.jpg";
import { Link } from "react-router-dom";
import RightArrow from "../../components/SVG";
import Breadcrumb from "../../components/Breadcrumb";
import ctaImg from "../../assets/img/about/cta-1.png";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const ApplicationMain = () => {
  const [isOpen, setIsOpen] = useState(false);

  const downloadFrom = () => {
    setIsOpen(true);
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  //     const items = [
  //   {
  //     icon: 'flaticon-user',
  //     title: 'Online Application for Full Membership',
  //     description:
  //       'Fill in your application and pay online.',
  //       link:"/signup"
  //   },
  //   {
  //     icon: 'flaticon-customer-review',
  //     title: 'Register for Full Membership',
  //     description:
  //       'Download PDF form and send in manually with payment',
  //   },
  //   {
  //     icon: 'flaticon-study',
  //     title: 'Register for Student Membership',
  //     description:
  //       'Download PDF form and send in manually with payment',
  //   },
  // ];
  return (
    <>
      <Breadcrumb title="Membership Application" />
      <Modal
        show={isOpen}
        onHide={toggleModal}
        centered
        size="lg"
        dialogClassName="edge-to-edge-modal"
        backdropClassName="no-backdrop-padding"
      >
        <Modal.Body className="position-relative pb-40 pt-40 pr-20 pl-20">
          <Button
            variant="light"
            onClick={toggleModal}
            style={{
              position: "absolute",
              top: "30px",
              right: "20px",
              zIndex: 2,
              borderRadius: "50%",
              padding: "0.2rem 0.6rem",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            ✕
          </Button>

          <div className="it-student-area it-instructor-style">
            <div className="row">
              <div className="col-xl-12">
                <div className="">
                  <form>
                    <div className="it-student-regiform">
                      <h1
                        className="it-student-regiform-title"
                        style={{
                          fontSize: "30px",
                          fontWeight: "bold",
                          marginBottom: "0px",
                        }}
                      >
                        Download Application Form
                      </h1>
                      <hr />
                      <div className="it-student-regiform-wrap">
                        <div className="row">
                          <p>
                            Please Enter the details to download the Application
                            form
                          </p>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>Full Name *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>City *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>Phone *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="it-student-regiform-item">
                              <label>Email Id *</label>
                              <input type="text" />
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <button type="submit" className="ed-btn-theme">
                              Submit
                              <i>
                                <RightArrow />
                              </i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* <div
        id="it-contact"
        className="it-contact-area it-contact-style-4 z-index p-relative pt-50 pb-50"
      >
        <div className="it-contact-shape-1 d-none d-lg-block">
          <img src={shapeImg1} alt="" />
        </div>
        <div className="it-contact-shape-2 d-none d-lg-block">
          <img src={shapeImg2} alt="" />
        </div>
        <div className="it-contact-shape-3 d-none d-xxl-block">
          <img src={shapeImg3} alt="" />
        </div>
        <div className="it-contact-shape-4 d-none d-lg-block">
          <img src={shapeImg4} alt="" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xl-7 col-lg-7 wow animate__fadeInLeft"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="it-contact-left">
                <div className="it-choose-area it-choose-style-2 z-index  p-relative">
                  <div className="it-choose-content-box">
                    {items.map((item, index) => (
                      <div
                        key={index}
                        className="it-choose-content d-flex align-items-center flex-wrap mb-30"
                      >
                        <div className="it-choose-icon">
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              width="50"
                              height="50"
                            >
                              <g
                                fill="none"
                                stroke="#fff"
                                strokeWidth="30"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                              >
                                <path d="M387.324 323.007l57.882 126.755-71.616-19.946L341.761 497l-52.726-115.464M123.355 325.901L66.794 449.762l71.616-19.946L170.239 497l55.401-121.323" />
                                <path d="M67.982 195.884c0-19.648 14.59-36.752 20.346-54.481 5.966-18.375 4.422-40.747 15.553-56.042 11.242-15.447 33.072-20.841 48.52-32.083 15.294-11.131 27.109-30.29 45.484-36.257 17.729-5.757 38.467 2.611 58.115 2.611 19.648 0 40.386-8.367 58.115-2.611 18.375 5.966 30.19 25.126 45.484 36.257 15.447 11.242 37.278 16.636 48.52 32.083 11.131 15.294 9.586 37.666 15.552 56.041 5.757 17.729 20.346 34.834 20.346 54.482 0 19.648-14.59 36.752-20.346 54.481-5.966 18.375-4.422 40.747-15.553 56.042-11.242 15.447-33.072 20.841-48.52 32.083-15.294 11.131-27.109 30.29-45.484 36.257-17.729 5.757-38.467-2.611-58.115-2.611-19.648 0-40.386 8.367-58.115 2.611-18.375-5.966-30.19-25.126-45.484-36.257-15.447-11.242-37.278-16.636-48.52-32.083-11.131-15.294-9.586-37.666-15.552-56.041-5.756-17.729-20.346-34.834-20.346-54.482z" />
                                <path d="M230.998 202.955l-22.022 8.86a31.362 31.362 0 0 0-19.657 29.097v29.491H322.68v-29.491a31.364 31.364 0 0 0-19.657-29.097l-22.022-8.86" />
                                <path d="M300.996 144.559c0-24.754-20.011-44.837-44.747-44.97h-.497c-24.736.139-44.748 20.216-44.748 44.97v18.421c0 24.839 20.148 44.976 45.003 44.976 24.854 0 45.003-20.136 45.003-44.976v-18.421z" />
                              </g>
                            </svg>
                          </span>
                        </div>
                        <div className="it-choose-text">
                          <h1 className="it-choose-title pb-10">
                            {item.title}
                          </h1>
                          <p className="mb-0">{item.description}</p>
                          {item.link ? (
                            <Link
                              className="ed-btn-theme mt-20"
                              to={item.link}
                              style={{ backgroundColor: "#704fe6" }}
                            >
                              DOWNLOAD NOW
                              <i style={{ backgroundColor: "#785dd7" }}>
                                <RightArrow />
                              </i>
                            </Link>
                          ) : (
                            <Link
                              className="ed-btn-theme mt-20"
                              onClick={downloadFrom}
                              to={item.link}
                              style={{ backgroundColor: "#704fe6" }}
                            >
                              DOWNLOAD NOW
                              <i style={{ backgroundColor: "#785dd7" }}>
                                <RightArrow />
                              </i>
                            </Link>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xl-5 col-lg-5 wow animate__fadeInRight"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div
                className="it-contact-wrap"
                style={{ backgroundImage: `url(${contactBG})` }}
              >
                <h1 style={{ color: "#2fc7a1" }}>Do you have any queries?</h1>
                <p className="text-white pb-15">
                  Please fill the form to get the answer of your queries
                </p>
                <form>
                  <div className="row">
                    <div className="col-12 mb-15">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Your Name" />
                      </div>
                    </div>
                    <div className="col-12 mb-15">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="Your Email" />
                      </div>
                    </div>
                    <div className="col-12 mb-15">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Phone" />
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="it-contact-textarea-box">
                        <textarea placeholder="Message"></textarea>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="ed-btn-theme">
                    Read More
                    <i>
                      <RightArrow />
                    </i>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="it-cta-area it-cta-height black-bg p-relative ">
        <div className="it-cta-bg d-none d-xl-block">
          <img src={ctaImg} alt="" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-9 col-xl-8 col-lg-7 col-md-7">
              <div className="it-cta-content">
                <h4 className="it-cta-title">Are you already a SAP Member?</h4>
                <p className=" it-cta-text text-white">
                  If you are unable to sign in, please email
                  contact@aquaprofessional.org for assistance
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-5">
              <div className="it-cta-button text-md-end">
                <Link
                  className="ed-btn-theme"
                  to="/login"
                  style={{ backgroundColor: "#704fe6" }}
                >
                  Sign in
                  <i style={{ backgroundColor: "#785dd7" }}>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ApplicationMain;
